import { render, staticRenderFns } from "./contractRoomType.vue?vue&type=template&id=dbc09b08&"
import script from "./contractRoomType.vue?vue&type=script&lang=js&"
export * from "./contractRoomType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports